// extracted by mini-css-extract-plugin
export default {"wide-button":"WideButton_wide-button__5oN8I"};